import { ListOption } from "../types";

export const toggleListOption = <T extends ListOption>(
    selected: T[],
    option: T,
): T[] => {
    const alreadySelected = selected.some((item) => item.id === option.id);

    if (alreadySelected) {
        return selected.filter((item) => item.id !== option.id);
    }

    return [...selected, option];
};

export const unitsToListOptions = (
    units: { code: string; name: string }[] | undefined,
): ListOption[] =>
    units?.map((unit) => ({
        id: unit.code,
        name: unit.name,
    })) ?? [];
